export default async function apiGet({
  url,
  fullUrl,
  query = {},
  config = {},
}) {
  if (!fullUrl) {
    const cleanUrl = url
      .replace(process.env.NEXT_PUBLIC_API_URL, '')
      .replace(/^\//, '')
    fullUrl = `${process.env.NEXT_PUBLIC_API_URL}/${cleanUrl}`
    if (!config.headers) config.headers = {}
    const d = new Date()
    config.headers['detected-tz-offset'] = -1 * (d.getTimezoneOffset() / 60)
    config.headers['detected-tz-name'] =
      Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone
  }
  if (Object.keys(query).length > 0) {
    if (!Array.isArray(query.includes)) {
      delete query.includes
    } else {
      if (query.includes.length < 1) {
        delete query.includes
      }
    }
    const params = new URLSearchParams(query)
    fullUrl += `?${params.toString()}`
  }
  const result = await fetch(fullUrl, {
    method: 'GET',
    next: { revalidate: 1 },
    ...config,
  })

  if (
    result.headers.get('content-type') !== 'application/json; charset=utf-8' &&
    result.status === 200
  ) {
    return result
  }

  const response =
    typeof result.json === 'function' ? await result.json() : result

  if (response.code && !['200', '204'].includes(String(response.code))) {
    throw new Error(response.message, { cause: response })
  }
  if (!['200', '204'].includes(String(result.status))) {
    throw new Error(result.statusText, {
      cause: {
        code: result.status,
        message: result.statusText,
      },
    })
  }
  return response
}
